import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

/**
 * A component that renders an empty cell with customizable content.
 * @param {Object} props - The props object containing the following properties:
 *   - clearSearchButton: A function to handle the clear search button click event.
 *   - noDataTitle: The title of the empty cell.
 *   - noDataDesc: The description of the empty cell.
 *   - emptyItems: The number of empty items in the cell.
 *   - noDataAddButton: A boolean indicating whether to show the add button.
 *   - noDataAddButtonTitle: The title of the add button.
 *   - emptyDataAddButton: A function to handle the empty data add button click event.
 * @returns The rendered empty
 */
const EmptyCell = (props) => {
  const { t } = useTranslation();

  /**
   * Destructures the properties object and assigns the values to individual variables.
   * @param {object} props - The properties object containing the values to destructure.
   * @returns None
   */
  const {
    clearSearchButton,
    noDataTitle,
    noDataDesc,
    emptyItems,
    clearButton,
  } = props;

  const emptyItemsLength = emptyItems;

  const noDataRef = useRef(null); // Create a ref for the .NoDataFoound element

  useEffect(() => {
    // Get the .NoDataFoound element using the ref
    const noDataElement = noDataRef.current;

    // Get the nearest <tr> ancestor element
    const nearestTr = noDataElement.closest("tr");

    // Add a class to the nearest <tr> element
    if (nearestTr) {
      nearestTr.classList.add("emptyRow"); // Replace "custom-class" with your desired class name
    }
  }, []);

  return (
    <div ref={noDataRef} className="NoDataFoound">
      <div className="NoData_Icon">
        <span className="Icon">
          <i className="bx bx-search-alt-2 bx-xs" />
        </span>
        <span className="No-Data-text">{noDataTitle}</span>
        {emptyItemsLength?.length === 0 ? (
          ""
        ) : (
          <span className="No-Desc">{noDataDesc}</span>
        )}
          { clearButton &&
          <button className="Fill_Button" onClick={clearSearchButton}>
            {t("CLEAR_SEARCH")}
          </button>}
      </div>
    </div>
  );
};

export default EmptyCell;
